module.exports = __webpack_public_path__ + "img/piekarnia.d14c57d1.jpg";